import { signal } from '@preact/signals';

export const skillSubtypeSignal = signal(false);